import React from 'react';
import { UserProvider, SignInProvider, ErrorProvider } from 'contexts';

const withProviders = (WrappedComponent) => {
  return () => (
    <UserProvider>
      <SignInProvider>
        <ErrorProvider>
          <WrappedComponent />
        </ErrorProvider>
      </SignInProvider>
    </UserProvider>
  );
};

export { withProviders };
